export default [
  {
    path: 'custom-functions',
    name: 'AdminCustomFunctions',
    component: () => import('@/views/admin/customfunction/List.vue'),
    meta: {
      headerText: 'Custom Functions Admin',
      headerBackRoute: 'AdminHome',
      subNav: 'custom-functions-admin'
    }
  }
]
